import { Link } from 'react-router-dom'

export default function Header() {
  return (
    <header className="bg-white border-b border-primary-200">
      <nav className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center space-x-2">
            <span className="text-xl font-bold text-primary-900">Ctrl+Z</span>
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <a href="#how-it-works" className="text-primary-600 hover:text-primary-900 text-sm">
              How It Works
            </a>
            <Link to="/docs" className="text-primary-600 hover:text-primary-900 text-sm">
              Docs
            </Link>
            <Link to="/swagger" className="text-primary-600 hover:text-primary-900 text-sm">
              API
            </Link>
            <a
              href="https://gitlab.com/mallocrun/ctrlz"
              className="text-primary-600 hover:text-primary-900 text-sm"
              target="_blank"
              rel="noopener noreferrer"
            >
              GitLab
            </a>
          </div>

          <div className="flex items-center space-x-4">
            <a
              href="/docs"
              className="hidden sm:inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-primary-700 hover:text-primary-900"
            >
              Documentation
            </a>
          </div>
        </div>
      </nav>
    </header>
  )
}
